<template>
  <div class="app-foot" :style="{ height: height + 'px' }">
    <div :class="{ 'app-foot-sticky': sticky }" ref="foot">
      <div v-if="showLink" class="app-foot-friend-link">
        <div class="app-foot-friend-container">
          <span class="app-foot-link-title">友情链接</span>
          <div class="app-foot-link-wrap">
            <a
              class="app-foot-link"
              v-for="(item, index) in linkList"
              :key="index"
              :href="item.link ? item.link : 'javascript:void(0);'"
              :target="item.link ? '_blank' : ''"
            >
              {{ item.label }}
            </a>
          </div>
        </div>
      </div>
      <!--      <div v-if="showContect" class="app-foot-contect">-->
      <!--        <div class="app-foot-contect-container">-->
      <!--          <div class="app-foot-contect-left">-->
      <!--            <p class="aafcl-t">-->
      <!--              <a :href="foothomePage || 'javascript:void(0);'">网站首页</a>-->
      <!--              <el-divider direction="vertical"></el-divider>-->
      <!--              <a :href="footPrivacy || 'javascript:void(0);'">隐私政策</a>-->
      <!--            </p>-->
      <!--            <p class="aafcl-b">-->
      <!--              Copyright © iFlytek, All Rights Reserved. 科大讯飞股份有限公司-->
      <!--            </p>-->
      <!--          </div>-->
      <!--          <div class="app-foot-contect-right">-->
      <!--            <span class="aafcr-phone">-->
      <!--              官方客服：<strong>{{ footphone }}</strong>-->
      <!--            </span>-->
      <!--            &lt;!&ndash; <span class="aafcr-extra">-->
      <!--            <el-divider direction="vertical"></el-divider>-->
      <!--            <el-popover>-->
      <!--              <el-button>hover 激活</el-button>-->
      <!--              <img slot="reference" src="" alt="" />-->
      <!--            </el-popover>-->
      <!--            <a href="javascript:void(0);">-->
      <!--              <img src="" alt="" />-->
      <!--            </a>-->
      <!--          </span> &ndash;&gt;-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div v-if="showCopyRight" class="app-foot-copyright">-->
      <!--        <span>主办: 安徽省教育厅    承办:安徽省教育科学研究院 安徽省电化教育馆 技术支持：科大讯飞股份有限公司</span>-->
      <!--        <span>版本号：{{ footversion }}</span>-->
      <!--        <span @click="goIcp" class="icp">备案号：{{ footNum }}</span>-->
      <!--      </div>-->
      <!-- <div class="footer">
        <div class="center-wrap">
          <div class="content">
            主办：安徽省教育厅&nbsp;&nbsp; 承办：安徽省教育科学研究院
            安徽省电化教育馆&nbsp;&nbsp; 技术支持：科大讯飞股份有限公司&nbsp;&nbsp;
            版本号：V2.1.1110&nbsp;&nbsp;
            <a class="ref" href="http://www.ahedu.cn/EduResource/index.php?app=resource&mod=Homepage&act=index">回顾旧版</a><br />
            <a
                class="ref bah"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402700955"
                target="_blank"
            ><img
                class="jh"
                src="~@/assets/img/home/jh.png"
            />皖公网安备：34010402700955号</a
            >&nbsp;&nbsp;<a
              class="ref bah"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402700955"
              target="_blank"
          >皖ICP备：05004075号-1</a
          >
          </div>
        </div>
      </div> -->

      <div class="footer">
        <div class="center-wrap container">
          <div class="se">
            <a href="https://www.smartedu.cn/" target="_blank">
              <img src="@/assets/img/home/se/footer.png" />
            </a>
            <div class="se-title">
              <a href="http://www.ah.smartedu.cn" target="_blank">
                <h1>{{ AppInfo.se.title }}</h1>
              </a>
              <!-- <h1>{{ AppInfo.se.title }}</h1> -->
              <p>{{ AppInfo.se.enTitle }}</p>
            </div>
          </div>

          <div class="content">
            <div>
              <span>主办：安徽省教育厅</span>
              <span>承办：安徽省教育科学研究院</span>
              <span>安徽省电化教育馆</span>
              <span>技术支持：科大讯飞股份有限公司</span>
              <span>版本号：V2.1.1110</span>
              <a
                class="ref"
                href="https://www.ahedu.cn/EduResource/index.php?app=resource&mod=Homepage&act=index"
                >回顾旧版</a
              >
            </div>
            <div>
              <a class="ref bah" :href="beian.gongwang.url" target="_blank"
                ><img class="jh" src="~@/assets/img/home/jh.png" />{{
                  beian.gongwang.text
                }}</a
              >
              <a class="ref bah" :href="beian.icp.url" target="_blank">{{
                beian.icp.text
              }}</a>
              <span>客服电话：4001-009-595</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppInfo from '@/config/AppInfo';
export default {
  name: '',
  components: {},
  props: {
    showContect: {
      type: Boolean,
      default: true,
    },
    showLink: {
      type: Boolean,
      default: false,
    },
    showCopyRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      height: 0,
      sticky: false,
      linkList: window.APP_CONFIG.footLink,
      footphone: window.APP_CONFIG.footphone,
      foothomePage: window.APP_CONFIG.foothomePage,
      footPrivacy: window.APP_CONFIG.footPrivacy,
      footversion: window.APP_CONFIG.footversion,
      footNum: window.APP_CONFIG.footNum,
      AppInfo,
      beian: {
        gongwang: {},
        icp: {},
      },
    };
  },
  mounted() {
    this.beian = window.beian;

    this.getSticky();
    window.addEventListener('load', this.getSticky);
    window.addEventListener('resize', this.getSticky);
    window.addEventListener('scroll', this.getSticky);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('load', this.getSticky);
      window.removeEventListener('resize', this.getSticky);
      window.removeEventListener('scroll', this.getSticky);
    });
    this.$parent.$on('hook:updated', () => {
      this.getSticky();
    });
  },
  computed: {},
  methods: {
    goIcp() {
      window.open('http://beian.miit.gov.cn', '_blank');
    },
    getHeight() {
      this.height = this.$refs.foot.clientHeight;
    },
    getSticky() {
      this.getHeight();
      let foot = this.$refs.foot;
      let wrap = foot.parentNode.parentNode;
      this.sticky = wrap.clientHeight < window.innerHeight;
    },
  },
};
</script>
<style scoped lang="less">
.footer {
  background: #303a4f;
  .center-wrap {
    padding: 0;
    white-space: nowrap;
    .content {
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 27px;
      padding: 7px 0;
      .ref {
        color: #368fff;
        &.bah {
          text-decoration: none;
          color: #fff;
        }
        .jh {
          padding-right: 7px;
          position: relative;
          top: 4px;
        }
      }
    }
  }
}

.app-foot {
  z-index: 100;
  width: 100%;
  .app-foot-sticky {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .app-foot-friend-link {
    background-color: #3e475c;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    .app-foot-friend-container {
      margin: 0 auto;
      padding: 28px 0 28px 27px;
      max-width: 1200px;
      display: flex;
    }
    .app-foot-link-title {
      margin-right: 20px;
      line-height: 35px;
    }
    .app-foot-link-wrap {
      flex: 1;
    }
    .app-foot-link {
      box-sizing: border-box;
      display: inline-block;
      margin: 0 20px 16px 0;
      padding: 0 10px;
      width: 198px;
      height: 35px;
      background: #4d586f;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 35px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .app-foot-contect {
    background-color: #303133;
    .app-foot-contect-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      max-width: 1200px;
      height: 120px;
      color: #ffffff;
    }
    .app-foot-contect-left {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      .aafcl-t {
        a {
          color: #ffffff;
        }
      }
    }
  }
  .app-foot-copyright {
    background-color: #303a4f;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
    span {
      margin: 20px;
    }
  }
}
.icp {
  cursor: pointer;
}
.title {
  height: 48px;
  font-size: 0;
  border-bottom: 1px solid #e7e9ec;
  position: relative;
  .label {
    color: #368fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 48px;
    position: relative;
    display: inline-block;
    padding-right: 6px;
    padding-left: 4px;
    &::before {
      content: ' ';
      width: 110px;
      height: 2px;
      background: #368fff;
      position: absolute;
      left: 0;
      bottom: -1px;
    }
  }
  .sub {
    font-size: 19px;
    font-weight: 600;
    color: #333333;
    line-height: 26px;
    opacity: 0.1;
  }
  .more {
    position: absolute;
    top: 15px;
    right: 0;
    cursor: pointer;
    width: 34px;
    height: 21px;
    line-height: 19px;
    padding-left: 6px;
    background: url('~@/assets/img/home/more_bg.png') no-repeat;
    background-size: contain;
    font-size: 12px;
    font-weight: 400;
    color: #85bbff;
  }
}
.center-wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 26px;
}
.footer {
  background: #303a4f;
  color: rgba(255, 255, 255, 0.5);

  .center-wrap {
    padding: 0;
    white-space: nowrap;
    .content {
      font-size: 12px;
      // color: #ffffff;
      text-align: center;
      line-height: 27px;
      padding: 7px 0;
      .ref {
        color: #368fff;
        &.bah {
          text-decoration: none;
          color: inherit;
        }
        .jh {
          padding-right: 7px;
          position: relative;
          top: 4px;
        }
      }

      span {
        margin-left: 1em;
      }

      a {
        margin-left: 1em;
      }
    }
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;

    .se {
      display: flex;
      align-items: center;
    }
    .se-title {
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      padding-left: 12px;
      margin-left: 12px;

      h1 {
        font-size: 18px;
        line-height: 25px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
      }
      p {
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
